export default __webpack_public_path__ + "static/media/OverviewHardDrive.b34f3a1d.svg";